import React from 'react'
import HomePageInfoSection from '../Components/HomePageInfoSection'
import Footer from '../Components/Footer'
import Contact from '../Contacts'
import MyInfo from '../MyInfo'
import HomePageMidBodySection from '../Components/HomePageMidBodySection'
import HomePageNavBar from '../Components/HomePageNavBar'
import ScreenTimeChallenge from '../Components/ScreenTimeChallenge'

function Homepage() {
  return (
    <>
        <HomePageNavBar />
        {/* <HomePageInfoSection /> */}
        {/* <MyInfo /> */}
        <ScreenTimeChallenge />
        <HomePageMidBodySection />
        <Contact />
        <Footer />
    </>
  )
}

export default Homepage